import { render, staticRenderFns } from "./DirectMessages.vue?vue&type=template&id=3100e13c&scoped=true&"
import script from "./DirectMessages.vue?vue&type=script&lang=js&"
export * from "./DirectMessages.vue?vue&type=script&lang=js&"
import style0 from "./direct-messages.css?vue&type=style&index=0&id=3100e13c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3100e13c",
  null
  
)

export default component.exports